/**
 * Platform publication colors are used inside the calendar where a single
 * strategy can contain several platform-specific slots.
 */

export const PLATFORM_PUBLICATION_COLORS: Readonly<Record<string, string>> = {
  linkedin: '#0A66C2',
  twitter: '#1D9BF0',
  x: '#111827',
  reddit: '#FF4500',
  instagram: '#C13584',
  tiktok: '#00B2A9',
  facebook: '#1877F2',
  youtube: '#DC2626',
  threads: '#4B5563',
  newsletter: '#7C3AED',
  blog: '#059669',
  email: '#D97706',
};

export const FALLBACK_PUBLICATION_COLOR = '#64748B';
export const REACTIVE_PUBLICATION_COLOR = '#D97706';

export function pickPlatformPublicationColor(platform: string | null | undefined): string {
  const key = String(platform ?? '').trim().toLowerCase();
  return PLATFORM_PUBLICATION_COLORS[key] ?? FALLBACK_PUBLICATION_COLOR;
}

export function isReactivePublicationSlot(publication: {
  source?: string;
  topicId?: string | null;
}): boolean {
  return publication.source === 'reactive' && !publication.topicId;
}
